var exports = {};

/*
 * In order to avoid confusion here is a list of terms
 * used throughout this code:
 * - octet: represent a byte or 8bits
 * - septet: represent 7bits
 * - character: a text unit, think one char is one glyph (Warning: this is an oversimplification and not always true)
 * - code point: a character value in a given encoding
 * - code unit: a single "block" used to encode a character
 *              UCS-2 is of fixed length and every character is 2 code units long
 *              GSM-7 is of variable length and require 1 or 2 code unit per character
 */
Object.defineProperty(exports, "__esModule", {
  value: true
}); // Map of Javascript code points to GSM-7

var UnicodeToGsm = {
  10: [10],
  12: [27, 10],
  13: [13],
  32: [32],
  33: [33],
  34: [34],
  35: [35],
  36: [2],
  37: [37],
  38: [38],
  39: [39],
  40: [40],
  41: [41],
  42: [42],
  43: [43],
  44: [44],
  45: [45],
  46: [46],
  47: [47],
  48: [48],
  49: [49],
  50: [50],
  51: [51],
  52: [52],
  53: [53],
  54: [54],
  55: [55],
  56: [56],
  57: [57],
  58: [58],
  59: [59],
  60: [60],
  61: [61],
  62: [62],
  63: [63],
  64: [0],
  65: [65],
  66: [66],
  67: [67],
  68: [68],
  69: [69],
  70: [70],
  71: [71],
  72: [72],
  73: [73],
  74: [74],
  75: [75],
  76: [76],
  77: [77],
  78: [78],
  79: [79],
  80: [80],
  81: [81],
  82: [82],
  83: [83],
  84: [84],
  85: [85],
  86: [86],
  87: [87],
  88: [88],
  89: [89],
  90: [90],
  91: [27, 60],
  92: [27, 47],
  93: [27, 62],
  94: [27, 20],
  95: [17],
  97: [97],
  98: [98],
  99: [99],
  100: [100],
  101: [101],
  102: [102],
  103: [103],
  104: [104],
  105: [105],
  106: [106],
  107: [107],
  108: [108],
  109: [109],
  110: [110],
  111: [111],
  112: [112],
  113: [113],
  114: [114],
  115: [115],
  116: [116],
  117: [117],
  118: [118],
  119: [119],
  120: [120],
  121: [121],
  122: [122],
  123: [27, 40],
  124: [27, 64],
  125: [27, 41],
  126: [27, 61],
  161: [64],
  163: [1],
  164: [36],
  165: [3],
  167: [95],
  191: [96],
  196: [91],
  197: [14],
  198: [28],
  201: [31],
  209: [93],
  214: [92],
  216: [11],
  220: [94],
  223: [30],
  224: [127],
  228: [123],
  229: [15],
  230: [29],
  199: [9],
  232: [4],
  233: [5],
  236: [7],
  241: [125],
  242: [8],
  246: [124],
  248: [12],
  249: [6],
  252: [126],
  915: [19],
  916: [16],
  920: [25],
  923: [20],
  926: [26],
  928: [22],
  931: [24],
  934: [18],
  936: [23],
  937: [21],
  8364: [27, 101]
};
exports.default = UnicodeToGsm; //# sourceMappingURL=UnicodeToGSM.js.map

export default exports;